import { createSelector } from 'reselect'

const getChannelFeatures = (state: any) => state.channelFeatures

/** A Redux selector to retrieve Channel Features Data
 * @param state - The Redux state
 * @param {object} - Channel Features Data.
 */

export const selectChannelFeatures = createSelector(
  getChannelFeatures,
  (data) => data && data.features ? data.features : null
)

/** A Redux selector to retrieve Channel Features loading
 * @param state - The Redux state
 * @param {Boolean} - Channel Features loading.
 */

 export const selectChannelFeaturesLoading = createSelector(
  getChannelFeatures,
  (data) => data && data.status ? data.status.inProgress : null
)

/** A Redux selector to retrieve Update Channel Features loading
 * @param state - The Redux state
 * @param {Boolean} - Update Channel Features loading.
 */

 export const selectUpdateFeaturesLoading = createSelector(
  getChannelFeatures,
  (data) => data && data.updateFeatures ? data.updateFeatures.inProgress : null
)

export const selectUpdateFeaturesStatus = createSelector(
  getChannelFeatures,
  (data) => data && data.updateFeatures ? data.updateFeatures.status : null
)

export const selectUpdateFeaturesError = createSelector(
  getChannelFeatures,
  (data) => data && data.updateFeatures ? data.updateFeatures.error : null
)
